import { Services } from "../services/Services.js";
import { Module } from "../ui/Module";

export class BasePage extends Module {

    constructor(parent, options) {

        super(parent, options);

        this.pageTitle = 'XXX - application error';
        this.errorDescription = 'Error description';
        this.errorRecomendation = 'Error recomendation';

    };

    // --------------------------------------------------------------------------

    _render(vm) {

        const ct = Services.get('templates');
        const page = this;

        return ct.module([
            ct.tag('header', [
                ct.h1('.text-ellipsis', [
                    page.pageTitle
                ]),
            ]),
            ct.tag('section', [
                ct.p([
                    ct.span('.bold', { '.innerHTML': page.errorDescription }, [])
                ]),
                ct.p({ '.innerHTML': page.errorRecomendation }, []),
            ]),
        ]);

    };

}
